import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import * as React from "react";

import { FormHelperText } from "@mui/material";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { User } from "lib/features/user/types";
import { setUser } from "lib/features/user/userSlice";
import { useAppDispatch } from "lib/hooks";
import { useNavigate } from "react-router-dom";
import { validateEmail } from "util/validation";
import logo from "../assets/icons/referee-main.svg";
import authServices from "../services/auth-service";

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="#">
        Referee
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const Login = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [emailError, setEmailError] = React.useState(false);
  const [passwordError, setPasswordError] = React.useState(false);
  const [isDisable, setIsDisable] = React.useState(false);
  const [invalidCredential, setInvalidCredential] = React.useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let canSendLoginRequest = true;
    setIsDisable(true);
    setEmailError(false);
    if (validateEmail(email) === false) {
      setEmailError(true);
      canSendLoginRequest = false;
      setIsDisable(false);
    }
    setPasswordError(!password);
    if (!password) {
      canSendLoginRequest = false;
      setIsDisable(false);
    }
    if (canSendLoginRequest) {
      const payload = {
        email,
        password,
      };
      authServices
        .login(payload)
        .then((result) => {
          const token = result?.data?.token;
          const user: User = result?.data?.user;
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user) as string);

          dispatch(setUser(user));
          navigate("/home");
          setIsDisable(false);
        })
        .catch((error) => {
          setInvalidCredential(error?.response?.data?.message);
          setIsDisable(false);
        });
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, p:1,bgcolor: "#fff", width: "70px", height: "90px" }}>
          <img
            src={logo}
            alt="logo"
            style={{ marginLeft: "auto", marginRight: "auto" }}
          />
        </Avatar>

        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            error={emailError}
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
          <TextField
            margin="normal"
            error={passwordError}
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
          <FormHelperText error={invalidCredential ? true : false}>
            {invalidCredential}
          </FormHelperText>
          <Button
            type="submit"
            disabled={isDisable}
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href="/forgot-password" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="/sign-up" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>
  );
};

export default Login;